import Head from "next/head";

import ForgotPasswordC from "@/components/auth/forgot-password";

import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";

export default function ForgotPassword() {
  return (
    <>
      <Head>
        <title>{seoData.FORGOT_PASSWORD.title}</title>
        <SeoMetaData data={seoData.HOW_IT_WORKS} />
      </Head>

      <ForgotPasswordC />
    </>
  );
}
